import BasicButton from '../components/button/BasicButton'
import FontIconSvg from '../components/font/iconfont'
import HtmlPanel from '../components/html/HtmlPanel'
import PageHelper from '../components/page/PageHelper'
export default {
  install: function (Vue) {
    Vue.component('icon-fontSvg', FontIconSvg)
    Vue.component('BasicButton', BasicButton)
    Vue.component('HtmlPanel', HtmlPanel)
    Vue.component('PageHelper', PageHelper)
  }
}



// WEBPACK FOOTER //
// ./src/components/index.js